import WebsiteProvider from "context/client/website";
import WebsiteAccessDataProvider from "context/client/website_access_data";
import WebsitesContent from "page_components/client/websites/Content";

const Websites = () => (
  <WebsiteProvider>
    <WebsiteAccessDataProvider>
      <WebsitesContent />
    </WebsiteAccessDataProvider>
  </WebsiteProvider>
);

export default Websites;
